module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-255.2528b169.svg";